export enum GeneralReportTiming {
    Daily = 'daily',
    Weekly = 'weekly',
    TwoWeeks = 'two-weeks',
    Monthly = 'monthly',
    TwoMonths = 'two-months',
    ThreeMonths = 'three-months',
    FourMonths = 'four-months',
    FiveMonths = 'five-months',
    SixMonths = 'six-months'
}